import React, { createContext, useContext } from 'react';
import { startGoogleOAuthLogin } from '../services/api';

const OAuthContext = createContext();

const OAUTH_UNAVAILABLE_MSG = 'Bu giriş yöntemi şu an kullanılamıyor. Lütfen e-posta ve şifre ile giriş yapın veya kayıt olun.';

export const OAuthProvider = ({ children }) => {
  const handleGoogleLogin = async () => {
    // Tam sayfa yönlendirme: backend Google'a yönlendirir, dönüşte
    // /oauth2/callback sayfasına JWT ile geri gelinir (bkz. OAuthCallback.jsx).
    startGoogleOAuthLogin();
  };

  const handleFacebookLogin = async () => {
    alert(OAUTH_UNAVAILABLE_MSG);
    window.location.href = '/login';
  };

  const value = {
    handleGoogleLogin,
    handleFacebookLogin
  };

  return (
    <OAuthContext.Provider value={value}>
      {children}
    </OAuthContext.Provider>
  );
};

export const useOAuth = () => {
  const context = useContext(OAuthContext);
  if (!context) {
    throw new Error('useOAuth hook OAuthProvider içinde kullanılmalıdır');
  }
  return context;
};

export default OAuthContext;

